<template>
    <div>
        <div class="page">
            <div class="container px-11 2xl:px-3 m-auto mt-14 mb-16">
                <title-s-chapter
                    :options="{
                        from: 'from-tango',
                        to: 'to-selective_yellow',
                    }"
                >
                    <h1
                        class="text-center mb-14"
                        v-html="currentPage.content.sArticleTitle.alt"
                    ></h1>
                </title-s-chapter>

                <div class="container-components">
                    <div class="relative mb-5">
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    `Interview Y. Baros : Les enjeux du CIH en 2021 et +`
                                ),
                            }"
                            class="top-2 right-2"
                        />
                        <img class="intro_img"
                            :src="
                                $i18n.locale +
                                '/images/pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage2.src
                            "
                        />
                    </div>
                    <div class="card  q10__article_container__content__paragraphs mb-4">
                    
                                <paragraph-first-letter-big
                                    :options="{
                                        letter: currentPage
                                .content.sParagraphOne_Title.text.substr(0, 1),
                                        color: 'text-tango',
                                    }"
                                />

                                <paragraph :options="{}">
                                    <span v-html="currentPage
                                .content.sParagraphOne_Title.text.slice(1)"></span>
                                    
                                </paragraph>
                    
                    </div>
                    <div class="card">
                        <span class="text-nandor 2xl:text-lg" v-html="currentPage.content.sParagraphOneTwo_Title.text"></span>
                        <div class="text-right" v-html="currentPage.content.sParagraphAuthor.text"></div>
                    </div>
                    <div class="card">
                        <div>
                            <div class="mt-8">
                                <h3 class="text-lg font-bold text-tundora" v-html="currentPage.content.sParagraphTwo_Title.title"></h3>
                                <p
                                    class="2xl:text-lg"
                                    v-html="
                                        currentPage.content.sParagraphTwo_Title.text
                                    "
                                ></p>
                            </div>
                            <div class="bg-tango rounded-full rounded-circle w-full h-full md:w-full md:h-full">
                                <div class="text-white w-3/4 text-rounded-circle">
                                    <div class="m-4 md:m-2 lg:m-4 leading-3">
                                        <h1
                                            class="text-lg lg:text-xs 2xl:text-3xl font-bold"
                                            v-html="
                                                currentPage.content
                                                    .sParagraphThree_Title.title
                                            "
                                        ></h1>
                                        <h3
                                            class="font-bold"
                                            v-html="
                                                currentPage.content
                                                    .sParagraphThree_Title.text
                                            "
                                        ></h3>
                                    </div>
                                    <div class="flex">
                                        <img
                                            class="arrow mr-4"
                                            :src="
                                                $i18n.locale +
                                                '/images/pages/' +
                                                currentPage.slug +
                                                '/' +
                                                currentPage.images.oImage1.src
                                            "
                                        />
                                        <span
                                            class="text-xs md:text-xs 2xl:text-base mb-2 md:mb-0 lg:mb-2"
                                            v-html="
                                                currentPage.content
                                                    .sParagraphFour_Title.text
                                            "
                                        ></span>
                                    </div>
                                    <div class="flex">
                                        <img
                                            class="arrow mr-4"
                                            :src="
                                                $i18n.locale +
                                                '/images/pages/' +
                                                currentPage.slug +
                                                '/' +
                                                currentPage.images.oImage1.src
                                            "
                                        />
                                        <span
                                            class="text-xs md:text-xs 2xl:text-base mb-2 md:mb-0 lg:mb-2"
                                            v-html="
                                                currentPage.content
                                                    .sParagraphFive_Title.text
                                            "
                                        ></span>
                                    </div>
                                    <div class="flex">
                                        <img
                                            class="arrow mr-4"
                                            :src="
                                                $i18n.locale +
                                                '/images/pages/' +
                                                currentPage.slug +
                                                '/' +
                                                currentPage.images.oImage1.src
                                            "
                                        />
                                        <span
                                            class="text-xs md:text-xs 2xl:text-base mb-2 md:mb-0 lg:mb-2"
                                            v-html="
                                                currentPage.content
                                                    .sParagraphSix_Title.text
                                            "
                                        ></span>
                                    </div>
                                    <div class="flex">
                                        <img
                                            class="arrow mr-4"
                                            :src="
                                                $i18n.locale +
                                                '/images/pages/' +
                                                currentPage.slug +
                                                '/' +
                                                currentPage.images.oImage1.src
                                            "
                                        />
                                        <span
                                            class="text-xs md:text-xs 2xl:text-base mb-2 md:mb-0 lg:mb-2"
                                            v-html="
                                                currentPage.content
                                                    .sParagraphSeven_Title.text
                                            "
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="fixed bottom-0 w-full h-10 bg-cornflower_blue" @click="openModal()">
                <button class="text-resolution_blue w-full h-full text-right p-2 pr-5">MENTIONS LÉGALES</button>
                <LegalMentions />
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";
import LegalMentions from '@/components/LegalMentions';

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
        LegalMentions
    },
    name : "PageTest",
    mixins: [PagesMixin],
    methods: {
        openModal() {
            $eventbus.$emit("modal-legal-mentions:show");
        }
    },
};
</script>

<style scoped lang='scss'>
.rounded-circle {
    width: 450px;
    height: 450px;
    @media (max-width: 1535px) {
        width: 400px;
        height: 400px;
    }
    @media (max-width: 1024px) {
        width: 350px;
        height: 350px;
    }
    @media (max-width: 912px) {
        width: 300px;
        height: 300px;
        margin: 0 auto;
    }
    @media (max-width: 768px) {
        width: 280px;
        height: 280px;
        margin: 0 auto;
    }
}

.text-rounded-circle {
    top: 48%;
    left: 50%;
    position: relative;
    transform: translate(-50%, -50%);
    @media (max-width: 768px) {
        top: 55%;
        left: 55%;
        font-size: 11px;
    }
    @media (max-width: 768px) {
        font-size: 11px;
        top: 52%;
        left: 55%;
    }
}

.arrow {
    width: 40px;
    height: 30px;
    margin: 10px;
    @media (max-width: 1535px) {
        width: 30px;
        height: 20px;
        margin: 10px;
    }
    @media (max-width: 1024px) {
        width: 15px;
        height: 15px;
        margin: 5px;
    }
    @media (max-width: 768px) {
        width: 15px;
        height: 15px;
        margin: 4px;
    }
}

.card{
    margin-bottom: 0;
}

.intro_img {
    height: 400px;
    object-fit: cover;
    margin: 0 auto;
}
</style>

